module.exports = __webpack_public_path__ + "static/media/mobile-bg.f0fa3cd7.jpg";